import React from "react";

function FlightHoldQueues() {
  return <div>FlightHoldQueues</div>;
}

export default FlightHoldQueues;
